export default "__VITE_ASSET__D68iYrkp__"